import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '../pages/home'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'homePage',
        component: Home
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router